module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"filelist-item-img\">\n    <div class=\"filelist-thumb\">\n        <a href=\"")
    ; __append(escapeFn( url ))
    ; __append(escapeFn(item.mainpath))
    ; __append("\" target=\"_blank\" class=\"fb\" rel=\"imglist_")
    ; __append(escapeFn( widgetId ))
    ; __append("\" data-fancybox-type=\"image\">\n            <img src=\"")
    ; __append(escapeFn( url ))
    ; __append(escapeFn( item.thumbpath || item.mainpath ))
    ; __append("\">\n        </a>\n        ")
    ;  if (typeof readonly == "undefined" || !readonly) { 
    ; __append("\n        <span class=\"filelist-delete-img\" data-id=\"")
    ; __append(escapeFn(item.id))
    ; __append("\"></span>\n        ")
    ;  } 
    ; __append("\n    </div>\n</div>\n")
  }
  return __output.join("");

}